module.exports = __webpack_public_path__ + "img/p2-12.b51664d0.png";